import * as AesirApi from 'services/yggdrasil/api/aesirApi'

export function getClient () {
    return {
        LoadChatSessions: async () =>
            AesirApi.loadFromAesir('chat'),
        LoadSingleChatHistory: async (chatId) =>
            AesirApi.loadFromAesir(`chat/${chatId}`),
        OpenNewChatSession: async () =>
            AesirApi.postToAesir('chat'),
        SendMessage: async (message, chatId) =>
            AesirApi.postToAesir(`chat/${chatId}`,
                {
                    content: message.message,
                    language: message.language
                }),
        SendChatBotFeedBack: async (messageId, chatId, feedbackPayload) =>
            AesirApi.postToAesir(`chat/${chatId}/feedback/${messageId}`, feedbackPayload)
    }
}
